<template>
  <div class="max-w-lg m-auto my-16">

    <BrokerpadLogo></BrokerpadLogo>

    <div class="p-8 bg-white mt-6 rounded shadow-lg border">

      <template v-if="confirmed">
        <div class="text-2xl font-light text-gray-700">
          Registration successful
        </div>

        <div class="mt-6 leading-normal text-base">
          Your account has been confirmed. You can now
          <router-link :to="{ name : 'auth-login' }" tag="a" class="text-blue-500 hover:text-blue-600 underline">login</router-link>
          with your email and password.
        </div>
      </template>

      <template v-else>
        <div class="text-2xl font-light text-gray-700">
          Registration unsuccessful
        </div>

        <div class="mt-6 leading-normal text-base">
          There is a an error trying to complete your registration.
         <br>
         Pleae contact help at 
         <a href='mailto:help@brokerpad.com.au' class="text-blue-500">help@brokerpad.com.au</a>
        </div>
      </template>
      
    </div>

    <div class="pl-8 mt-6">
      <PublicFooter />
    </div>
  </div>
</template>

<script>

  import axios          from "axios";
  import PublicFooter   from "@/shared/components/public/Footer";
  import BrokerpadLogo  from '@/shared/components/BrokerpadLogo';

  export default {

    components : {
      BrokerpadLogo,
      PublicFooter
    },

    data () {
      return {
        confirmed: null,
      }
    },

    mounted() {
      document.body.className = 'bg-gray-100'
    },

    beforeDestroy() {
      document.body.className = ''
    },

    created() {      
      // is the user still logged in? make sure the user is logged out
      localStorage.removeItem("bp-broker-jwt")
      this.$store.commit('setIsLoggedIn', false)

      axios.post(process.env.VUE_APP_API_URL + '/api/auth/confirm-registration', {
        token: this.$route.params.token,
      })
      .then(response => {
        this.confirmed = true
      })
      .catch(e => {
        this.confirmed = false
      })
    },
  }
</script>